var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 600"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Icons_Selected_12_Question"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons_Selected_12_Question",
    clipPath: "url(#clip-Icons_Selected_12_Question)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons_Selected_12_Question-2",
    "data-name": "Icons_Selected_12_Question",
    transform: "translate(-6.048 5.499)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shadow_Layer",
    transform: "translate(81.924 50.571)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 262.062,
    cy: 262.062,
    r: 262.062,
    fill: "#eaeaea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(6.048 12.478)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(194.201 474.751)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M92.6,154.935c-17.312,6.11-32.249,28.175-28.854,50.579,5.092,33.606,38.7,40.735,60.763,33.606,24.441-7.808,40.056-48.543,18.67-72.644-12.9-14.257-35.3-16.973-50.579-11.542",
    transform: "translate(-63.257 -152.334)",
    fill: "#ffe149"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(158.637)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M80.344,203.667a102.359,102.359,0,0,0,20.707,1.7c24.1,0,40.4-3.055,43.111-28.854,2.376-21.725-10.863-46.845,9.844-62.8,16.973-13.239,50.919-6.11,65.515,8.147,28.175,27.5,9.165,77.736-22.744,91.993-27.5,12.56-59.745,30.212-73.323,58.726-8.826,18.67-16.973,41.753-19.349,62.46-7.129,62.121,2.037,93.691,37.34,93.691,51.937,0,40.4-96.746,81.81-118.132,71.286-36.662,106.929-72.644,96.406-169.05C312.533,76.71,272.477,15.607,200.851,12.552c-31.23-1.358-86.9,15.955-119.489,60.084-13.239,17.991-27.5,44.13-28.175,67.213-.339,17.652-3.055,44.13,11.881,56.69C69.481,200.273,74.912,202.309,80.344,203.667Z",
    transform: "translate(-52.78 -12.478)",
    fill: "#ffe149"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(0 4.475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M171.2,523a7.99,7.99,0,0,1-2.716-.679C62.914,476.151-2.262,367.864,6.9,252.787,15.729,141.445,93.8,45.378,201.074,14.148a8.486,8.486,0,0,1,4.752,16.294c-100.819,29.193-173.8,119.15-182.289,223.7C15.051,362.093,75.814,463.591,174.936,506.7c4.413,1.7,6.11,6.789,4.413,11.2A8.04,8.04,0,0,1,171.2,523",
    transform: "translate(-6.048 -13.796)",
    fill: "#4c4c4c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(306.953 47.643)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M104.035,510.536a8.284,8.284,0,0,1-7.468-7.129,8.937,8.937,0,0,1,6.789-9.844A253.27,253.27,0,0,0,313.141,263.41C319.93,177.188,282.929,94.7,214.359,41.744a8.486,8.486,0,1,1,10.184-13.578A270.75,270.75,0,0,1,106.071,509.857a2.494,2.494,0,0,1-2.037.679",
    transform: "translate(-96.472 -26.513)",
    fill: "#4c4c4c"
  })))))));
};
export default __webpack_public_path__ + "static/media/Icons_Selected_12_Question.0f7d7abc.svg";
export { SvgComponent as ReactComponent };